import WizardInput from 'componentes/wizard/WizardInput.js';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
import MyModal from 'helpers/MyModal.js';
import EditDelegacionProfeco from 'pages/Administration/_EditDelegacionProfeco.js';
import EditDeterminante from 'pages/Administration/_EditDeterminante.js';
import EditSubcustomer from 'pages/Administration/_EditSubcustomer.js';
import EditTipoEvento from 'pages/Configuration/_EditTipoEvento.js';
import IconButton from 'componentes/common/IconButton.js';
import { Controller } from 'react-hook-form';
import { useQuejaWizardContext } from 'context/QuejaWizardProvider';
const URIAdmin = ApiEndpoint + 'administration/';
const URIconfig = ApiEndpoint + 'configuration/';
const ExpedienteData = ({ register, errors, setValue, onChange, control }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openDeterminante, setOpenDeterminante] = useState(false);

  const {
    selectedDelegacionDescription,
    setSelectedDelegacionDescription,
    selectedSubcustomerDescription,
    setSelectedSubcustomerDescription,
    selectedDeterminanteDescription,
    setSelectedDeterminanteDescription,
    setFormatoQuejaSelected
  } = useQuejaWizardContext();
  const [openTipoDeEvento, setOpenTipoDeEvento] = useState(false);
  const [openSubcliente, setOpenSubcliente] = useState(false);
  const [openDelegacion, setOpenDelegacion] = useState(false);
  const [customers, setCustomers] = useState(null);
  const [subCustomers, setSubCustomers] = useState([]);
  const [determinantes, setDeterminantes] = useState([]);
  const [idCustomer, setIdCustomer] = useState(null);
  const [idSubCustomer, setIdSubCustomer] = useState(null);
  const [tiposEvento, setTiposEvento] = useState(null);
  const [delegacionesProfeco, setDelegacionesProfeco] = useState(false);

  const handleCloseDelegacionProfeco = () => {
    setOpenDelegacion(false);
    getDelegacionesProfeco();
  };
  const handleCloseTipoDeEvento = () => {
    setOpenTipoDeEvento(false);
    getTiposEventos();
  };
  const handleCloseSubcliente = () => {
    setOpenSubcliente(false);
    getSubCustomers();
  };
  const handleCloseDeterminante = () => {
    setOpenDeterminante(false);
    getDeterminantes();
  };
  const getCustomers = async () => {
    setCustomers(null);

    httpClient('GET', URIAdmin + 'customers/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data.map(item => {
            return { value: item.idcliente, label: item.razonsocial };
          });
          setCustomers(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getDelegacionesProfeco = async () => {
    setDelegacionesProfeco(null);

    httpClient('GET', URIAdmin + 'delegations/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return { id: item.iddelegacion, description: item.nombre };
          });
          setDelegacionesProfeco(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getSubCustomers = async () => {
    setSubCustomers(null);

    httpClient(
      'GET',
      URIAdmin + 'subcustomers/' + idCustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          var subcustList = response.data.map(item => {
            return {
              id: item.idsubcliente,
              description: item.determinanate + ' - ' + item.descripcion
            };
          });
          setSubCustomers(subcustList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getDeterminantes = async () => {
    setDeterminantes(null);

    httpClient(
      'GET',
      URIAdmin + 'determinantes/' + idSubCustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          var subcustList = response.data.map(item => {
            return {
              id: item.iddeterminante,
              description: item.determinante + ' - ' + item.unidad
            };
          });
          setDeterminantes(subcustList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getTiposEventos = async () => {
    setTiposEvento(null);

    httpClient('GET', URIconfig + 'eventtypes/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var tiposPlataforma = response.data.map(item => {
            return { value: item.idtipoeventos, label: item.descripcion };
          });
          setTiposEvento(tiposPlataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getFormatoQueja = async ({ idDeterminante }) => {
    setFormatoQuejaSelected(null);

    httpClient(
      'GET',
      URIAdmin + 'determinante/' + idDeterminante,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setFormatoQuejaSelected(response.data.idformatoqueja);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (idCustomer) getSubCustomers();
  }, [idCustomer]);
  useEffect(() => {
    if (idSubCustomer) getDeterminantes();
  }, [idSubCustomer]);
  useEffect(() => {
    if (!delegacionesProfeco) getDelegacionesProfeco();
    if (!customers) getCustomers();
    if (!tiposEvento) getTiposEventos();
  }, []);
  return (
    <>
      <Row className="g-2 mb-3">
        <Col>
          <Controller
            name="expedienteTipo"
            control={control}
            rules={{ required: true }}
            render={field => (
              <WizardInput
                label="Expediente"
                name="expedienteTipo"
                type="inputmask"
                value={field.value}
                onChange={field.onChange}
                mask="aaa" //PFC.GTO.B.3/000569-2025
                errors={errors}
                formGroupProps={{ className: 'mb-1' }}
                formControlProps={{
                  ...register('expedienteTipo', { required: true })
                }}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="expedienteUbi"
            control={control}
            rules={{ required: true }}
            render={field => (
              <WizardInput
                label="_"
                name="expedienteUbi"
                type="inputmask"
                value={field.value}
                onChange={field.onChange}
                mask="aaa" //PFC.GTO.B.3/000569-2025
                errors={errors}
                formGroupProps={{ className: 'mb-1' }}
                formControlProps={{
                  ...register('expedienteUbi', { required: true })
                }}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="expedienteClave"
            control={control}
            rules={{ required: true }}
            render={field => (
              <WizardInput
                label="_"
                name="expedienteClave"
                type="inputmask"
                value={field.value}
                onChange={field.onChange}
                mask="a" //PFC.GTO.B.3/000569-2025
                errors={errors}
                formGroupProps={{ className: 'mb-1' }}
                formControlProps={{
                  ...register('expedienteClave', { required: true })
                }}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="expedienteId"
            control={control}
            rules={{ required: true }}
            render={field => (
              <WizardInput
                label="_"
                name="expedienteId"
                type="inputmask"
                value={field.value}
                onChange={field.onChange}
                mask="9" //PFC.GTO.B.3/000569-2025
                errors={errors}
                formGroupProps={{ className: 'mb-1' }}
                formControlProps={{
                  ...register('expedienteId', { required: true })
                }}
              />
            )}
          />
        </Col>
        <Col>
          {' '}
          <WizardInput
            label="_"
            name="expediente"
            type="inputmask"
            mask="999999.9999" //PFC.GTO.B.3/000569-2025
            errors={errors}
            onChange={onChange}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('expediente', { required: true })
            }}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          <WizardInput
            label="Folio Preconciliacion"
            name="preconciliacion"
            type="text"
            errors={errors}
            onChange={onChange}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('preconciliacion', { required: true })
            }}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          {delegacionesProfeco && delegacionesProfeco.length > 0 && (
            <AutocompleteDropdown
              items={delegacionesProfeco}
              addFunction={() => {
                setOpenDelegacion(true);
              }}
              addButton={true}
              name="delegacion"
              register={register}
              errors={errors}
              placeholder="Selecciona una Delegacion"
              currentSelected={selectedDelegacionDescription}
              setCurrentSelected={value => {
                setSelectedDelegacionDescription(value.description);
                //setIdSubCustomer(value.id);
              }}
              setValue={setValue}
            />
          )}
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        {customers && (
          <WizardInput
            label="Cliente"
            type="select"
            name="cliente"
            errors={errors}
            options={customers}
            onChange={e => {
              setIdCustomer(e.target.value);
            }}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('cliente', { required: true })
            }}
          />
        )}
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          {' '}
          <AutocompleteDropdown
            items={subCustomers || []}
            placeholder="Selecciona un Sub Cliente"
            currentSelected={selectedSubcustomerDescription}
            name="subcustomer"
            register={register}
            errors={errors}
            addFunction={() => {
              if (idCustomer == 0) return;
              setOpenSubcliente(true);
            }}
            addButton={true}
            setCurrentSelected={value => {
              setSelectedSubcustomerDescription(value.description);
              setIdSubCustomer(value.id);
            }}
            setValue={setValue}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          {' '}
          <AutocompleteDropdown
            items={determinantes || []}
            placeholder="Selecciona un Determinante"
            currentSelected={selectedDeterminanteDescription}
            name="determinante"
            addFunction={() => {
              if (idCustomer == 0) return;
              setOpenDeterminante(true);
            }}
            addButton={true}
            register={register}
            errors={errors}
            setCurrentSelected={value => {
              console.log('selectedDeterminante', value);
              getFormatoQueja({ idDeterminante: value.id });
              setSelectedDeterminanteDescription(value.description);
            }}
            setValue={setValue}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          <IconButton
            variant="falcon-default"
            size="sm"
            icon="plus"
            style={{ float: 'right', marginRight: '5px', fontSize: 'smallest' }}
            transform="shrink-3"
            onClick={() => setOpenTipoDeEvento(true)}
          >
            Agregar
          </IconButton>
          {tiposEvento && (
            <WizardInput
              label="Tipo de Evento"
              type="select"
              name="idtipoevento"
              errors={errors}
              options={tiposEvento}
              onChange={e => {
                console.log(e.target.value);
                // setFormatoQueja(e.target.value);
              }}
              formGroupProps={{ className: 'mb-3' }}
              formControlProps={{
                ...register('idtipoevento', { required: true })
              }}
            />
          )}
        </Col>
      </Row>
      {openDelegacion && (
        <MyModal
          id="id_myModal"
          title={'Agregar Delegacion Profeco'}
          openModal={openDelegacion}
          closeModal={handleCloseDelegacionProfeco}
        >
          <EditDelegacionProfeco
            idDelegacionProfeco={0}
            closeModal={handleCloseDelegacionProfeco}
          ></EditDelegacionProfeco>
        </MyModal>
      )}
      {openDeterminante && idCustomer && (
        <MyModal
          id="id_myModal"
          title={'Agregar Determinante'}
          openModal={openDeterminante}
          closeModal={handleCloseDeterminante}
        >
          <EditDeterminante
            idDeterminante={0}
            idCustomer={idCustomer}
            closeModal={handleCloseDeterminante}
          ></EditDeterminante>
        </MyModal>
      )}{' '}
      {openSubcliente && idCustomer && (
        <MyModal
          id="id_myModal"
          title={'Agregar SubCliente'}
          openModal={openSubcliente}
          closeModal={handleCloseSubcliente}
        >
          <EditSubcustomer
            idSubcustomer={0}
            idCustomer={idCustomer}
            closeModal={handleCloseSubcliente}
          ></EditSubcustomer>
        </MyModal>
      )}
      {openTipoDeEvento && (
        <MyModal
          id="id_myModal"
          title={'Agregar Tipo de Evento'}
          openModal={openTipoDeEvento}
          closeModal={handleCloseTipoDeEvento}
        >
          <EditTipoEvento
            idTipoEvento={0}
            closeModal={handleCloseTipoDeEvento}
          ></EditTipoEvento>
        </MyModal>
      )}
    </>
  );
};
ExpedienteData.propTypes = {
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func,
  errors: PropTypes.object,
  watch: PropTypes.func,
  onChange: PropTypes.func,
  control: PropTypes.object
};
export default ExpedienteData;
